import React,{useReducer} from 'react';
import './App.css';
import Header from './components/MainComponents/Header'
import Footer from './components/MainComponents/Footer';
import {reducer as reducerAuth,initialState as initialStateAuth ,AuthProvider} from './components/shop/Contexts/AuthContext'
import {reducer as reducerCart,initialState as initialStateCart,CartProvider} from './components/shop/Contexts/CartContext'
import {reducer as reducerLoading,initialState as initialStateLoading,LoadingProvider} from './components/shop/Contexts/LoadingContext'
import LoadingBar from 'react-top-loading-bar';
import {MenuProvider,initialState, MenuReducer} from './components/Context/MenuContext';
import Menu from './components/MainComponents/Menu';
import HamburgerMenu from './components/MainComponents/HamburgerMenu';

function AppShop(props) {
  const [AuthState, AuthDispatch] = useReducer(reducerAuth, initialStateAuth);
  const [CartState, CartDispatch] = useReducer(reducerCart, initialStateCart);
  const [LoadingState, LoadingDispatch] = useReducer(reducerLoading, initialStateLoading);
  const [state, dispatch] = useReducer(MenuReducer, initialState)
  window.scrollTo(0, 0)
  return (
    <div className="App container-fluid">
      <AuthProvider value={{AuthState, AuthDispatch}}>
      <CartProvider value={{CartState,CartDispatch}}>
      <LoadingProvider value={{LoadingState,LoadingDispatch}}>
        <div id="header-container" className="bottom-line">
          <Header></Header>
        </div>
        <div className="contenitore container">
        <LoadingBar progress={LoadingState.progress} height={LoadingState.height} color={LoadingState.color}></LoadingBar>
          <div style={{position:"absolute",left:0,top:0}}>
          <MenuProvider value={{state, dispatch}}>
              <HamburgerMenu></HamburgerMenu>
          </MenuProvider>
          </div>
          {props.children}
        </div>
        <Footer></Footer>
        </LoadingProvider>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default AppShop;
